"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Colors = void 0;
/** Colors that can be used for the state of an icon (if not provided by icon directly) */
var Colors;
(function (Colors) {
    Colors["Default"] = "#666666";
    Colors["Error"] = "#c93a47";
    Colors["Success"] = "#008057";
    Colors["Link"] = "#1a699e";
    Colors["Inverse"] = "#ffffff";
    Colors["Discrete"] = "#4996b2";
    Colors["Continuous"] = "#00b180";
})(Colors || (exports.Colors = Colors = {}));
